export const DATE_PICKER_MIN_YEAR = 1800;

export const getDefaultDatePickerMinDate = () =>
  new Date(DATE_PICKER_MIN_YEAR, 0, 1);

export const getDefaultDatePickerMaxDate = () => {
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 25);
  return maxDate;
};
